import { createSlice } from "@reduxjs/toolkit";
import { getDoctorConsultationClaims } from "../../reducer/insuranceDoctorConsultation/insuranceDoctorConsultationReducer";

const initialState = {
  data: {
    claims: [],
    pagination: {},
  },
  isLoading: false,
  error: null,
};

const doctorConsultationClaimsSlice = createSlice({
  name: "doctorConsultationClaims",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDoctorConsultationClaims.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDoctorConsultationClaims.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(getDoctorConsultationClaims.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default doctorConsultationClaimsSlice.reducer;
